/** Document upload size limit for intake (must match backend INTAKE_MAX_UPLOAD_MB). */
export const INTAKE_MAX_UPLOAD_MB = parseInt(
  process.env.REACT_APP_INTAKE_MAX_UPLOAD_MB || "5",
  10
);

export const INTAKE_MAX_UPLOAD_BYTES = Math.max(1, INTAKE_MAX_UPLOAD_MB) * 1024 * 1024;

export const INTAKE_UPLOAD_TOO_LARGE_MSG =
  "Please upload a document up to 5 MB only.";

/** Chatbot intake: PDF, Word, TXT, JPG, PNG only. */
export const INTAKE_ALLOWED_UPLOAD_EXTS = [
  ".pdf",
  ".doc",
  ".docx",
  ".txt",
  ".jpg",
  ".jpeg",
  ".png",
];

export const INTAKE_UPLOAD_ACCEPT =
  ".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png";

export const INTAKE_UPLOAD_UNSUPPORTED_MSG =
  "Unsupported file format. Please upload a PDF, Word, TXT, JPG, or PNG file.";

export function intakeUploadExt(filename) {
  const n = String(filename || "").toLowerCase();
  const i = n.lastIndexOf(".");
  return i >= 0 ? n.slice(i) : "";
}

export function isIntakeUploadTypeAllowed(file) {
  if (!file?.name) return false;
  return INTAKE_ALLOWED_UPLOAD_EXTS.includes(intakeUploadExt(file.name));
}

export function isIntakeUploadTooLarge(file) {
  return Boolean(file && file.size > INTAKE_MAX_UPLOAD_BYTES);
}

/** Map API / network errors to the single upload size message when applicable. */
export function intakeUploadSizeError(err) {
  if (err?.response?.status === 413) return INTAKE_UPLOAD_TOO_LARGE_MSG;
  const bodyMsg = String(
    err?.response?.data?.error || err?.response?.data?.message || ""
  );
  if (
    err?.response?.status === 400 &&
    /5\s*mb|too large|entity too large|limit_file_size|file too large|up to 5 mb/i.test(
      bodyMsg
    )
  ) {
    return INTAKE_UPLOAD_TOO_LARGE_MSG;
  }
  const msg = String(
    err?.response?.data?.error || err?.response?.data?.message || err?.message || ""
  );
  if (
    /too large|entity too large|limit_file_size|up to 5 mb|exceeds the \d+ mb/i.test(
      msg
    )
  ) {
    return INTAKE_UPLOAD_TOO_LARGE_MSG;
  }
  return null;
}
